import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  tipo: [],
  level: [],
  dataFinal: null,
  dataInicial: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
